// extracted by mini-css-extract-plugin
module.exports = {"status":"status_status__1hDvW","status-form":"status_status-form__2ebwS","editIconcls":"status_editIconcls__2kDN2"};